import { vehicleStatusText } from '@utils/dictionaries/vehiclesStatusColors';

const alarmsFieldsInfo = {
  // Battery, Consumption, grid, solar
  Pri: { step: '0.01', unit: '' }, // Prioridad
  BtTy: { step: '0.01', unit: '' }, // Tipo de batería
  SysM: { step: '0.01', unit: '' }, // Modo de sistema
  DerM: { step: '0.01', unit: '' }, // Modo de reducción
  Time: { step: '0.01', unit: 'h' }, // Tiempo de trabajo total
  Temp: { step: '0.01', unit: '°C' }, // Temperatura SPH
  TIPM: { step: '0.01', unit: '°C' }, // Temperatura IPM
  TemB: { step: '0.01', unit: '°C' }, // Aumento temperatura
  // Solar, Grid, Battery
  SPHS: { step: '0.01', unit: '%' }, // Estado SPH
  // Battery, Solar
  SOH: { step: '0.01', unit: '%' }, // Estado vida útil
  // Battery
  BtV: { step: '0.01', unit: 'V' }, // Voltaje de batería
  SOC: { step: '0.01', unit: '%' }, // Estado de carga
  BtT: { step: '0.01', unit: '°C' }, // Temperatura de batería
  BtS: { step: '0.01', unit: '' }, // Estado batería BMS
  SOCB: { step: '0.01', unit: '%' }, // Estado de carga BMS //
  BtVB: { step: '0.01', unit: 'V' }, // Voltaje de batería BMS
  BtCB: { step: '0.01', unit: 'A' }, // Corriente batería BMS
  BtTB: { step: '0.01', unit: '°C' }, // Temperatura batería BMS
  BtMC: { step: '0.01', unit: 'A' }, // Máxima corriente de carga y descarga
  BtCy: { step: '0.01', unit: '' }, // Contador de ciclos
  DisED: { step: '0.01', unit: 'kWh' }, // Energía descargada hoy
  DisET: { step: '0.01', unit: 'kWh' }, // Energía descargada total
  ChED: { step: '0.01', unit: 'kWh' }, // Energía cargada hoy
  ChET: { step: '0.01', unit: 'kWh' }, // Energía cargada total
  ACCD: { step: '0.01', unit: 'kWh' }, // Energía de red cargada hoy
  ACCT: { step: '0.01', unit: 'kWh' }, // Energía de red cargada total
  DisP: { step: '0.01', unit: 'W' }, // Potencia de descarga
  ChrP: { step: '0.01', unit: 'W' }, // Potencia de carga
  // Consumption
  ELd: { step: '0.01', unit: 'kWh' }, // Energía a la carga
  PLdT: { step: '0.01', unit: 'W' }, // Potencia inversor
  LConT: { step: '0.01', unit: '' }, // Consumo total Carga
  PAuC: { step: '0.01', unit: '' }, // Potencia Autoconsumo
  // grid
  GpAV: { step: '0.01', unit: 'V' }, // Voltaje fase A
  GpAC: { step: '0.01', unit: 'A' }, // Corriente fase A
  GpAP: { step: '0.01', unit: 'W' }, // Potencia fase A
  GpBV: { step: '0.01', unit: 'V' }, // Voltaje fase B
  GpBC: { step: '0.01', unit: 'A' }, // Corriente fase B
  GpBP: { step: '0.01', unit: 'W' }, // Potencia fase B
  GpCV: { step: '0.01', unit: 'V' }, // Voltaje fase C
  GpCC: { step: '0.01', unit: 'A' }, // Corriente fase C
  GpCP: { step: '0.01', unit: 'W' }, // Potencia fase C
  EGD: { step: '0.01', unit: 'kWh' }, // Energía de red hoy
  EGT: { step: '0.01', unit: 'kWh' }, // Energía de red total
  EGL: { step: '0.01', unit: 'kWh' }, // Energía a la carga
  ImED: { step: '0.01', unit: 'kWh' }, // Energía importada hoy
  ImET: { step: '0.01', unit: 'kWh' }, // Energía importada total
  ExED: { step: '0.01', unit: 'kWh' }, // Energía exportada hoy
  ExET: { step: '0.01', unit: 'kWh' }, // Energía exportada total
  GPw: { step: '0.01', unit: 'W' }, // Salida de potencia AC
  ImPT: { step: '0.01', unit: 'W' }, // Potencia importada total
  ExPT: { step: '0.01', unit: 'W' }, // Potencia exportada total
  GF: { step: '0.01', unit: '' }, // Frecuencia de red
  PF: { step: '0.01', unit: '' }, // Factor de potencia
  IPF: { step: '0.01', unit: '' }, // Salida factor de potencia SPH
  ExLm: { step: '0.01', unit: 'W' }, // Limite de potencia aparente
  ROP: { step: '0.01', unit: '%' }, // Porcentaje de potencia real
  OMP: { step: '0.01', unit: 'W' }, // Limite de potencia máxima
  ApP: { step: '0.01', unit: 'W' }, // Potencia aparente
  ReaP: { step: '0.01', unit: 'W' }, // Potencia reactiva real
  ReaN: { step: '0.01', unit: 'W' }, // Potencia reactiva nominal
  ReaG: { step: '0.01', unit: 'W' }, // Potencia reactiva generada
  // Solar
  pv1: { step: '0.01', unit: 'V' }, // Voltage panel 1
  pc1: { step: '0.01', unit: 'A' }, // Current panel 1
  pw1: { step: '0.01', unit: 'W' }, // Power panel 1
  pv2: { step: '0.01', unit: 'V' }, // Voltage panel 2
  pc2: { step: '0.01', unit: 'A' }, // Current panel 2
  pw2: { step: '0.01', unit: 'W' }, // Power panel 2
  pv3: { step: '0.01', unit: 'V' }, // Voltage panel 3
  pc3: { step: '0.01', unit: 'A' }, // Current panel 3
  pw3: { step: '0.01', unit: 'W' }, // Power panel 3
  pED: { step: '0.01', unit: 'kWh' }, // PV energy today
  pET: { step: '0.01', unit: 'kWh' }, // PV energy total
  pPT: { step: '0.01', unit: 'W' }, // PV power total
  vol: {
    step: '0.01',
    unit: 'V',
  },
  cur: {
    step: '0.01',
    unit: 'A',
  },
  spe: {
    step: '1',
    unit: 'km/h',
  },
  acc: {
    step: '0.01',
    unit: '%',
    formatter: (value) => Math.floor(value * 100),
    parser: (value) => value / 100,
  },
  mot: {
    step: '1',
    unit: '°C',
  },
  soc: {
    step: '0.01',
    unit: '%',
    formatter: (value) => Math.floor(value * 100),
    parser: (value) => value / 100,
  },
  odo: {
    step: '1',
    unit: 'km',
  },
  sta: {
    options: Object.entries(vehicleStatusText).reduce((acc, cur) => {

      const [value, name] = cur;
      if (!['OFF', 'ON', 'CHA'].includes(value)) return acc;
      // eslint-disable-next-line no-param-reassign
      acc = [...acc, { value, name }];
      return acc;

    }, []),
    mode: 'multiple',
  },
  dte: {
    step: '1',
    unit: '°C',
  },
  // bra: {
  //   radioOptions: [
  //     { value: true, name: 'abierta' },
  //     { value: false, name: 'cerrada' },
  //   ],
  // },
};

export default alarmsFieldsInfo;
